<template>
  <div
    class="w-full h-80 absolute bottom-0 left-0 z-10 bg-card-100 border-t border-neutral-100/10 p-16"
  >
    <div class="flex items-center justify-between">
      <div class="flex items-center gap-8">
        <OButton
          v-if="alternativa?.template_evidencia?.length > 0"
          secondary
          class="w-48 h-48"
          @click="$emit('changeAba', 'Template')"
        >
          <q-icon
            size="1.5rem"
            color="icon-100"
            name="svguse:#icon_folder"
          />
          <q-tooltip v-bind="tooltipProps">
            {{ t('evidenceTemplate') }}
          </q-tooltip>
        </OButton>
        <OButton
          v-if="alternativa?.case_sucesso?.length > 0"
          secondary
          class="w-48 h-48"
          @click="$emit('changeAba', 'CaseSucesso')"
        >
          <q-icon
            size="1.5rem"
            color="icon-100"
            name="svguse:#icon_award"
          />
          <q-tooltip v-bind="tooltipProps">
            {{ t('caseSuccesses') }}
          </q-tooltip>
        </OButton>
        <OButton
          v-if="alternativa?.tem_contato_case_sucesso"
          secondary
          class="w-48 h-48"
          @click="$emit('changeAba', 'Contato')"
        >
          <q-icon
            size="1.5rem"
            color="icon-100"
            name="svguse:#icon_phone"
          />
          <q-tooltip v-bind="tooltipProps">
            {{ t('caseContact') }}
          </q-tooltip>
        </OButton>
      </div>
      <div class="flex items-center gap-8">
        <OButton
          disable
          secondary
          size="md"
          :label="t('ignoreAction')"
          class="text-headline-3 !min-w-96"
          @click="$emit('click:ignore')"
        />
        <OButton
          primary
          size="md"
          :label="t('saveAction')"
          class="text-headline-3 !min-w-96"
          @click="$emit('click:save')"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { tooltipProps } from 'js/utils/GLOBAL'
import { useI18n } from 'vue-i18n'
import OButton from 'components/Button/OButton.vue'

const { t } = useI18n()

const props = defineProps({
  abaAtiva: {
    type: String,
    default: 'Default',
  },
  alternativa: Object,
})

const emit = defineEmits(['changeAba', 'click:ignore', 'click:save'])
</script>

<style lang="scss" scoped></style>
